var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-fluid footer--payment-and-social wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('Payment', {
    attrs: {
      "content": _vm.content
    }
  }), _vm._v(" "), _c('Socials', {
    attrs: {
      "content": _vm.content,
      "is-scramble-link": _vm.isScrambleLink
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };